import React from "react";

const ChervonDown = () => {
    return <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M0.220115 0.216693C0.361098 0.0779445 0.552285 0 0.751634 0C0.950983 0 1.14217 0.0779445 1.28315 0.216693L5.00454 3.88021L8.72592 0.216693C8.86771 0.0818767 9.05762 0.00727798 9.25474 0.00896425C9.45186 0.0106505 9.64042 0.0884868 9.77981 0.225708C9.91919 0.36293 9.99826 0.548557 9.99997 0.74261C10.0017 0.936663 9.92591 1.12362 9.78896 1.2632L5.53606 5.44997C5.39508 5.58872 5.20389 5.66667 5.00454 5.66667C4.80519 5.66667 4.614 5.58872 4.47302 5.44997L0.220115 1.2632C0.0791756 1.12441 0 0.936196 0 0.739947C0 0.543697 0.0791756 0.355483 0.220115 0.216693Z"
            fill="currentColor"/>
    </svg>
}

export default ChervonDown;
